export const REGEX_EMAIL_VALIDATION = {
	value:
		// eslint-disable-next-line max-len
		/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
	message: 'Invalid email.',
}

export const REGEX_PASSWORD_VALIDATION = {
	value:
		// eslint-disable-next-line max-len
		/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}$/,
	message:
		'Password must contain at least 8 Latin characters, upper or lower letter, numbers 0-9.',
}

export const REGEX_PHONE_VALIDATION = {
	value: /^\+?[1-9]\d{10,14}$/,
	message: 'Invalid phone number',
}

export const REGEX_CONFIRM_CODE_VALIDATION = {
	value: /^(\d){6}$/,
	message: 'Please check your code.',
}

export const REGEX_FT_VALIDATION = {
	value: /^\d+('?([0-9]|1[0-1]))?$/g,
	message: 'Invalid value.',
}

export const REGEX_URL_VALIDATION = {
	value: new RegExp(
		'^(https?:\\/\\/)?' + // validate protocol
			'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
			'((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
			'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
			'(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
			'(\\#[-a-z\\d_]*)?$',
		'i'
	), // validate fragment locator
	message: 'Please make sure the URL you entered is correct.',
}